if (!customElements.get('sticky-add-to-cart')) {
  customElements.define(
    'sticky-add-to-cart',
    class StickyAddToCart extends HTMLElement {
      connectedCallback() {
        this.trigger = document.getElementById(this.dataset.triggerId);
        this.submitButton = this.querySelector('.sticky-add-to-cart__submit');

        if (!this.trigger || !this.submitButton) return;

        this.hidden = false;

        this.visibilityObserver = new IntersectionObserver(
          (entries) => this.handleIntersection(entries[0]),
          { threshold: 0 },
        );
        this.visibilityObserver.observe(this.trigger);

        this.stateObserver = new MutationObserver(() => this.syncButtonState());
        this.stateObserver.observe(this.trigger, {
          attributes: true,
          attributeFilter: ['class', 'aria-disabled', 'disabled'],
        });
        this.syncButtonState();

        this.sizeObserver = new ResizeObserver(() => this.syncHeight());
        this.sizeObserver.observe(this);
        this.syncHeight();
      }

      disconnectedCallback() {
        this.visibilityObserver?.disconnect();
        this.stateObserver?.disconnect();
        this.sizeObserver?.disconnect();
        document.body.classList.remove('has-sticky-add-to-cart');
      }

      handleIntersection(entry) {
        const scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        this.classList.toggle('sticky-add-to-cart--visible', scrolledPast);
        document.body.classList.toggle('has-sticky-add-to-cart', scrolledPast);
      }

      syncHeight() {
        document.documentElement.style.setProperty(
          '--sticky-add-to-cart-height',
          `${this.offsetHeight}px`,
        );
      }

      syncButtonState() {
        const isLoading = this.trigger.classList.contains('loading');
        const isDisabled =
          this.trigger.disabled || this.trigger.getAttribute('aria-disabled') === 'true';

        this.submitButton.classList.toggle('loading', isLoading);
        this.submitButton.disabled = isDisabled;
        this.submitButton.toggleAttribute('aria-disabled', isDisabled);

        const spinner = this.submitButton.querySelector('.loading__spinner');
        spinner?.classList.toggle('hidden', !isLoading);
      }
    },
  );
}
